import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "alignItems", "justifyContent", "flexDirection", "flexWrap", "children", "gap", "display"];
import styled from 'styled-components';
import { Layout } from './Layout';
import { jsx as _jsx } from "react/jsx-runtime";
const FlexContainer = styled(Layout).withConfig({
  displayName: "LayoutFlex__FlexContainer",
  componentId: "mtrjk9-0"
})(["", ";", ";", ";", ";"], ({
  $alignItems
}) => $alignItems && `align-items: ${$alignItems}`, ({
  $flexDirection
}) => $flexDirection && `flex-direction: ${$flexDirection}`, ({
  $flexWrap
}) => $flexWrap && `flex-wrap: ${$flexWrap};`, ({
  $justifyContent
}) => $justifyContent && `justify-content: ${$justifyContent};`);
export const LayoutFlex = _ref => {
  let {
      as,
      alignItems,
      justifyContent,
      flexDirection,
      flexWrap,
      children,
      gap = 'space',
      display = 'flex'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(FlexContainer, Object.assign({}, rest, {
    $alignItems: alignItems,
    $flexDirection: flexDirection,
    $flexWrap: flexWrap,
    $justifyContent: justifyContent,
    display: display,
    forwardedAs: as,
    gap: gap,
    children: children
  }));
};